import React from "react"
import {connect} from "react-redux";
import {bindActionCreators} from "redux";
import {push} from "react-router-redux";
import {setNotification} from "../../../actions/notifications-actions";
import {passwordChange} from "../../../actions/auth-actions";
import YCComponent from "../../yc-component";

class StudentGroupProfile extends YCComponent {

    render() {
        return (
            <div className='container'>
                <div className='row'>
                    <div className={this.mainContainerClass}>
                        <h1>Nastavení</h1>
                    </div>
                </div>
            </div>
        )
    }
}


function mapStateToProps(state,ownProps) {
    return {
        auth: state.auth
    };
}

function matchDispatchToProps(dispatch){
    return bindActionCreators({
        setNotification: setNotification,
        push: push,
        passwordChange: passwordChange,
    }, dispatch);
}

export default connect(mapStateToProps, matchDispatchToProps)(StudentGroupProfile);
